module.exports = __webpack_public_path__ + "img/logo1.1f65d2c3.png";